<template>
  <div id="app">
    <c-loading v-if="loading && !inLoader" @click="loading = !loading" />
    <transition name="router">
      <router-view v-if="!loading || inLoader" />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState("app", {
      appName: "name",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
    }),
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("user", {
      isSignIn: "isSignIn",
    }),
  },
  mounted() {
    this.smartScale();
    this.$store.dispatch("user/signCheck").then((isSignIn) => {
      if (isSignIn) {
        this.$store.dispatch("user/get").then(this.auth);
      } else {
        setTimeout(this.auth, 500);
      }
    });
    window.addEventListener("resize", this.smartScale);
  },
  methods: {
    smartScale() {
      const width = document.body.offsetWidth;
      const height = document.body.offsetHeight;
      let scaleWidth = width;
      if (width / height > 1920 / 1080) {
        scaleWidth = height * (1920 / 1080);
      }
      scaleWidth = scaleWidth < 1200 ? 1200 : scaleWidth;
      document.querySelector("html").style.fontSize = scaleWidth / 19.2 + "px";
      document.body.style.fontSize = 16 + "px";
      document.body.style.minWidth = 900 + "px";
    },
    auth() {
      if (this.$route.meta.requiresAuth && !this.isSignIn) {
        this.$store.dispatch("user/signIn");
      }
    },
  },
  watch: {
    $route(to) {
      window.scrollTo(0, 0);
      document.title = to.name || this.appName;
      if (!this.loading) this.auth();
    },
  },
};
</script>

<style lang="scss">
@import url("./assets/iconfont/iconfont.css");

* {
  width: auto;
  height: auto;
  box-sizing: border-box;
  border: none;
  outline: none;
  text-decoration: none;
  user-select: none;
  letter-spacing: 0.1em;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  background: transparent;
  font-weight: normal;
  font-family: "Helvetica-Now-Display-Regular", "Alibaba-PuHuiTi-Regular",
    "Helvetica Neue", Helvetica, "Microsoft Yahei", Arial, sans-serif;

  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 15px;
    height: 15px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 7px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.3);

    &:hover {
      background-color: rgba(255, 255, 255, 0.5);
    }
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 0;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.05);
  }
}

html {
  &[lang="ja-JP"] * {
    font-family: "Helvetica-Now-Display-Regular", "NotoSansJP",
      "Alibaba-PuHuiTi-Regular", "Helvetica Neue", Helvetica, "Microsoft Yahei",
      Arial, sans-serif;
  }

  body {
    height: auto;
    min-height: 100vh;
    margin: 0;
    background: #171717;
    font-feature-settings: unset;
    font-variant: unset;

    #app {
      min-height: inherit;
    }
  }
}

input,
textarea {
  user-select: text;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.router-enter-active {
  transition: opacity 0.5s;
}
.router-leave-active {
  opacity: 0;
  display: none;
}

.router-enter {
  opacity: 0;
}

@font-face {
  font-family: "Alibaba-PuHuiTi-Regular";
  src: url("https://cdn-font.angrymiao.com/Alibaba-PuHuiTi-Regular.eot#")
      format("embedded-opentype"),
    url("https://cdn-font.angrymiao.com/Alibaba-PuHuiTi-Regular.woff")
      format("woff"),
    url("https://cdn-font.angrymiao.com/Alibaba-PuHuiTi-Regular.ttf")
      format("truetype"),
    url("https://cdn-font.angrymiao.com/Alibaba-PuHuiTi-Regular.otf")
      format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "Helvetica-Now-Display-Regular";
  src: url("https://cdn-font.angrymiao.com/Monotype-Helvetica-Now-Display.eot#")
      format("embedded-opentype"),
    url("https://cdn-font.angrymiao.com/Monotype-Helvetica-Now-Display.woff")
      format("woff"),
    url("https://cdn-font.angrymiao.com/Monotype-Helvetica-Now-Display.ttf")
      format("truetype"),
    url("https://cdn-font.angrymiao.com/Monotype-Helvetica-Now-Display.otf")
      format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "NotoSansJP";
  src: url("https://cdn-font.angrymiao.com/NotoSansJP-Regular.otf")
    format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "iconfont";
  src: url("./assets/iconfont/iconfont.woff2?t=1620121422741") format("woff2"),
    url("./assets/iconfont/iconfont.woff?t=1620121422741") format("woff"),
    url("./assets/iconfont/iconfont.ttf?t=1620121422741") format("truetype");
}
</style>
